/**
 * @file        KybConsoleEntry.jsx
 * @module      modules/kyb/manager
 * @description App.js entry for /kyb-manager/*: the review console with the
 *              app's sign-out (same as the /home landing page). ASAP admins
 *              get a "Back to ASAP" link to their own home.
 */

import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { authuser, logout } from "../../../store/Authentication/AuthSlice";
import { ACL_ROUTE } from "../../../utils/constant";
import ReviewConsole from "./console/ReviewConsole";

export default function KybConsoleEntry() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector(authuser);
  const role = user?.userroles;

  const signOut = useCallback(() => {
    const done = () => {
      localStorage.clear();
      navigate("/auth/login");
    };
    dispatch(logout()).then(done, done);
  }, [dispatch, navigate]);

  // Roles with the ASAP app as well (air_admin, ocean_admin) get a way back to it.
  const home = role && role !== "kyb_manager" ? (ACL_ROUTE[role] || []).find((p) => p !== "/kyb-manager") : null;

  return <ReviewConsole onSignOut={signOut} backTo={home || undefined} />;
}
